import { Benefit } from '@/@types/benefits';
import { InsuranceActivationStatus, InsuranceServiceName } from '@/@types/insurance';
import type { InsurancePackageState } from '@/@types/insurance';
import type { TrackingEvent } from '@/@types/trackingEvent';
import { TrackingEvents } from '@/tracking/trackingEvents';

type AragServiceConfig = {
  benefit: Benefit;
  overviewTrackingEvent: TrackingEvent;
  phoneNumber: string;
};

export const ARAG_SERVICE_CONFIG: Record<InsuranceServiceName, AragServiceConfig> = {
  [InsuranceServiceName.RECHTSBERATUNG]: {
    benefit: Benefit.RECHTSBERATUNG,
    overviewTrackingEvent: TrackingEvents.RECHTSBERATUNG.OVERVIEW_VISITED,
    phoneNumber: '0211 209933399',
  },
  [InsuranceServiceName.MIETRECHTSSCHUTZ]: {
    benefit: Benefit.MIETRECHTSSCHUTZ,
    overviewTrackingEvent: TrackingEvents.MIETRECHTSSCHUTZ.OVERVIEW_VISITED,
    phoneNumber: '0211 2098901886',
  },
  [InsuranceServiceName.SCHLUESSELDIENST]: {
    benefit: Benefit.SCHLUESSELDIENST,
    overviewTrackingEvent: TrackingEvents.SCHLUESSELDIENST.OVERVIEW_VISITED,
    phoneNumber: '0211 98901405',
  },
  [InsuranceServiceName.MEDIATION]: {
    benefit: Benefit.MEDIATION,
    overviewTrackingEvent: TrackingEvents.MEDIATION.OVERVIEW_VISITED,
    phoneNumber: '0211 2098901886',
  },
};

// Keep the activation semantics identical to the legacy ARAG modal: PENDING services may be used.
export const isAragServiceActive = (
  insurancePackage: InsurancePackageState | null | undefined,
  serviceName: InsuranceServiceName,
) =>
  Boolean(
    insurancePackage &&
      [InsuranceActivationStatus.ACTIVATED, InsuranceActivationStatus.PENDING].includes(insurancePackage.status) &&
      insurancePackage.services.includes(serviceName),
  );
